import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RECEIVER_TEAMS_FILTER, StaffSearch } from './staff-search';

/**
 * Search box and role filter of a staff picker, shared by the alarm route recipients and the receiver
 * team members (ES-7564). The picker owns the StaffSearch and uses it to decide what it shows.
 */
@Component({
  selector: 'staff-filter-bar',
  template: `
    <input type="search" class="form-control form-control-sm" data-testid="staff-search"
           [placeholder]="('SEARCH' | translate) + '...'" [attr.aria-label]="'SEARCH' | translate"
           [(ngModel)]="search.text" [ngModelOptions]="{ standalone: true }">
    <select class="form-control form-control-sm" data-testid="staff-role-filter"
            [attr.aria-label]="'ROLE' | translate" [(ngModel)]="search.role" [ngModelOptions]="{ standalone: true }">
      <option value="">{{ 'ROLE' | translate }}: {{ 'ALL' | translate }}</option>
      @if (showReceiverTeams) {
        <option [value]="receiverTeamsFilter" data-testid="staff-filter-receiver-teams">{{ 'RECEIVER_TEAMS' | translate }}</option>
      }
      @for (entry of search.roleOptions; track entry.key) {
        <option [value]="entry.key">{{ entry.nameKey ? (entry.nameKey | translate) : entry.name }}</option>
      }
    </select>
  `,
  styles: [`
    :host { display: grid; grid-template-columns: minmax(0, 3fr) minmax(0, 2fr); gap: 0.5rem; }
  `],
  // Default: the StaffSearch is changed in place by the picker too (e.g. reset)
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [FormsModule, TranslateModule],
})
export class StaffFilterBarComponent {
  @Input({ required: true }) search: StaffSearch;
  /** Offer "Receiver teams" as a filter (pickers that list teams) */
  @Input() showReceiverTeams = false;

  readonly receiverTeamsFilter = RECEIVER_TEAMS_FILTER;
}
